/* eslint-disable import/prefer-default-export */
import { stringify } from "qs";
import request from "../request";
import { url } from "../service-utils";

export async function getLogSearchWithPage(params) {
  return request(
    `${url.log}/operation/log/pageList?${stringify(params)}`
  );
}

export async function getLogSearch(params) {
  return request(`${url.log}/operation/log/list?${stringify(params)}`);
}
